import { render } from "./Price.vue?vue&type=template&id=0bac48ea&scoped=true"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"

import "./Price.vue?vue&type=style&index=0&id=0bac48ea&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-0bac48ea"

export default script